export default __webpack_public_path__ + "static/media/1inch.496df386.jpeg";